import apiCreator from './util/ApiCreator';
const api = apiCreator('/api/dealer-portal/dealer-payments');

export default {

    createSquarePaymentCard (requestBody) {
        return api.post(`/square/card`, requestBody);
    },

    deleteSquarePaymentCard (squareCardId) {
        return api.delete(`/square/card/${squareCardId}`);
    },
}
